import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, Dialog, InputAdornment, TextField, useMediaQuery} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {NumericFormat} from "react-number-format";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
        />
    );
});

const AddFeeDialog = ({ open, onClose, onConfirm }) => {
    const sizeMatch = useMediaQuery('@media (min-width:600px)')
    const [description, setDescription] = useState('')
    const [value, setValue] = useState('')

    const handleClose = () => {
        setDescription('')
        setValue('')
        onClose()
    }

    const handleConfirm = () => {
        const totalInCents = Math.round(value * 100)
        onConfirm({ description, total: totalInCents, category: 'other' })
        setDescription('')
        setValue('')
    }

    const isValid = description.trim() && value > 0

    return (
        <Dialog
            fullScreen={!sizeMatch}
            sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: '600px' }, padding: 2 }}
            maxWidth="xs"
            open={open}
            onClick={event => event.stopPropagation()}
        >
            <DialogTitle>{"Adicionar Item na Fatura"}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Descrição"
                    fullWidth
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    sx={{ mt: 1 }}
                />
                <TextField
                    margin="dense"
                    label="Valor"
                    fullWidth
                    required
                    sx={{ mt: 2 }}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        inputComponent: NumericFormatCustom,
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Button onClick={handleClose}>{"Cancelar"}</Button>
                <Button
                    variant={"contained"}
                    onClick={handleConfirm}
                    disabled={!isValid}
                >
                    {"Adicionar"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddFeeDialog
